/**
 * @generated SignedSource<<7f830ee02f1f30fbe037b9a19ae8c348>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateHolidayCalendarEntryInput = {
  name?: string | null;
  year?: number | null;
  month?: number | null;
  day?: number | null;
  holidayCalendarId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createHolidayCalendarEntryMutation$variables = {
  input: CreateHolidayCalendarEntryInput;
};
export type createHolidayCalendarEntryMutation$data = {
  readonly createHolidayCalendarEntry: {
    readonly holidayCalendarEntry: {
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"settingsHolidayCalendars_holidayCalendarEntry">;
      } | null;
    } | null;
  } | null;
};
export type createHolidayCalendarEntryMutation = {
  variables: createHolidayCalendarEntryMutation$variables;
  response: createHolidayCalendarEntryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createHolidayCalendarEntryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHolidayCalendarEntryPayload",
        "kind": "LinkedField",
        "name": "createHolidayCalendarEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayCalendarEntryTypeEdge",
            "kind": "LinkedField",
            "name": "holidayCalendarEntry",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HolidayCalendarEntry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "settingsHolidayCalendars_holidayCalendarEntry"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createHolidayCalendarEntryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHolidayCalendarEntryPayload",
        "kind": "LinkedField",
        "name": "createHolidayCalendarEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayCalendarEntryTypeEdge",
            "kind": "LinkedField",
            "name": "holidayCalendarEntry",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HolidayCalendarEntry",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "year",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "month",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "day",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08e21683051ae67ab62335919e2c2dc2",
    "id": null,
    "metadata": {},
    "name": "createHolidayCalendarEntryMutation",
    "operationKind": "mutation",
    "text": "mutation createHolidayCalendarEntryMutation(\n  $input: CreateHolidayCalendarEntryInput!\n) {\n  createHolidayCalendarEntry(input: $input) {\n    holidayCalendarEntry {\n      node {\n        ...settingsHolidayCalendars_holidayCalendarEntry\n        id\n      }\n    }\n  }\n}\n\nfragment settingsHolidayCalendars_holidayCalendarEntry on HolidayCalendarEntry {\n  id\n  name\n  year\n  month\n  day\n}\n"
  }
};
})();

(node as any).hash = "e7aac779fda1dde9f80d2881c2fcdbec";

export default node;
